import {
    GET_ERRORS
} from './type';
import SellerUser from '../Models/SellerUser';
import BuyerUser from '../Models/BuyerUser';
import AffiliatorUser from '../Models/AffiliatorUser';

export const sellerLogin = (sellerData, history) => dispatch => {
    SellerUser.create(sellerData)
        .then(res => {
            if (parseInt(res.data.status) === 200) {
                window.localStorage.setItem('info', JSON.stringify(res.data.payload))
                history.push('/seller-dashboard');
            } else {
                dispatch({
                    type: GET_ERRORS,
                    payload: '正しい情報入力してください！'
                })
            }

        })
        .catch(
            // dispatch({
            //     type: GET_ERRORS,
            //     payload: res.data.message
            // })
            // err=>this.setState({errors:err.response.data})
        )
    // return {
    //     type: SELLER_LOGIN,
    //     payload: sellerData,
    // }
};
export const buyerLogin = (buyerData, history) => dispatch => {
    BuyerUser.create(buyerData)
        .then(res => {
            if (parseInt(res.data.status) === 200) {
                if ((localStorage.getItem('link')) === null || (localStorage.getItem('link')) === '') {
                    window.localStorage.setItem('info', JSON.stringify(res.data.payload))
                    history.push('/buyer-transaction');
                }else{
                   let  link = localStorage.getItem('link')
                     window.localStorage.setItem('info', JSON.stringify(res.data.payload))
                     history.push(link);
                }
            } else {
                dispatch({
                    type: GET_ERRORS,
                    payload: '正しい情報入力してください！'
                })
            }

        })
        .catch()
};
export const affiliatorLogin = (data, history) => dispatch => {
    AffiliatorUser.create(data)
        .then(res => {
            if (parseInt(res.data.status) === 200) {
                window.localStorage.setItem('info', JSON.stringify(res.data.payload))
                history.push('/affiliator-dashboard');
            } else {
                dispatch({
                    type: GET_ERRORS,
                    payload: '正しい情報入力してください！'
                })
            }

        })
        .catch()
};